import React from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import Backend from '../../../services/Backend';
import SaveIcon from '@mui/icons-material/SaveAsOutlined';
import './UserListSaveDialog.css';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { FormattedMessage, injectIntl } from 'react-intl';

class UserLoadSaveDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      dialogOpen: false,
    };
  }

  onOpenClicked() {
    this.setState({
      dialogOpen: true,
      name: '',
      email: '',
    });
  }

  onCloseClicked() {
    this.setState({
      dialogOpen: false,
    });
  }

  onNameChanged(event) {
    this.setState({
      name: event.target.value,
    });
  }

  onSaveClicked() {
    const products = this.props.products;
    const payload = {
      name: this.state.name,
      email: this.state.email,
      products: products.map((x) => x.id),
    };
    Backend.saveUserList(payload).then(() => {
      if (this.props.onSave) {
        this.props.onSave(this.state.name);
      }
      this.setState({
        name: '',
        dialogOpen: false,
      });
    });
  }

  render() {
    const products = this.props.products || [];

    return (
      <div className={`userlistSave ${this.props.className}`}>
        <Button
          disabled={this.props.disabled}
          onClick={
            this.props.disabled ? () => {} : this.onOpenClicked.bind(this)
          }
          startIcon={<SaveIcon name="floppy-o" />}
        >
          <FormattedMessage id="userList.saveSearch" />
        </Button>

        <Dialog
          modal={false}
          open={this.state.dialogOpen}
          onRequestClose={this.onCloseClicked.bind(this)}
          fullWidth
        >
          <DialogTitle><FormattedMessage id="userList.saveSearch" /></DialogTitle>
          <DialogContent>
            <div className="userListFields">
              <div className="left">
                <div className="chosenProductsText">
                  {`${products.length} `}<FormattedMessage id="userList.selectedProducts" />
                </div>
                <TextField
                  id={'save-searches-textfield'}
                  label={this.props.intl.formatMessage({ id: 'userList.nameLabel' })}
                  value={this.state.name}
                  variant="standard"
                  onChange={this.onNameChanged.bind(this)}
                />
                {/* <TextField
                  id={'save-searches-textfield'}
                  value={this.state.name}
                  onChange={this.onNameChanged.bind(this)}
                  floatingLabelText={'Namn'}
                  errorText={
                    !this.state.name && 'Skriv ett namn på din sparade sökning'
                  }
                /> */}
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            {' '}
            <Button onClick={this.onCloseClicked.bind(this)}>
              <FormattedMessage id="common.cancel" />
            </Button>
            <Button
              secondary
              keyboardFocused
              disabled={!this.state.name}
              onClick={this.onSaveClicked.bind(this)}
            >
              <FormattedMessage id="common.save" />
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default injectIntl(UserLoadSaveDialog);
